import { db, storage } from '@/main.js'
import moment from 'moment'

export default {
  data() {
    return {
      is_saving: false
    }
  },
  validations: {
    item: {}
  },
  filters: {
    capitalise: function(v) {
      return v.charAt(0).toUpperCase() + v.slice(1)
    },
    pluralise: function(v) {
      return v + 's'
    },
    date: function(v) {
      if (!v) {
        return ''
      }

      try {
        return moment(v.toDate()).format('DD/MM/YY')
      } catch(err) {
        return moment(v).format('DD/MM/YY')
      }
    }
  },
  methods: {
    async upload_image(file) {
      let id = db.collection('random').doc().id
      let snap = await storage.ref().child(`media/${id}.png`).put(file, {'cacheControl': 'max-age=2628000, public'})

      return `https://storage.googleapis.com/${this.config.firebase_config.storageBucket}/media/${id}.png` // await snap.ref.getDownloadURL()
    },
    validate_state(name) {
      const { $dirty, $error } = this.$v.item[name];
      return $dirty ? !$error : null;
    },
    async edit_item() {
      this.$v.item.$touch()
      if (this.$v.item.$anyError) {
        return
      }

      this.item.updated = new Date()

      this.is_saving = true
      await this.$firestoreRefs.item.update(this.item)
      if (this.after_write) {
        await this.after_write()
      }
      this.is_saving = false
    },
    async delete_item() {

      let result = await this.$swal({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      })

      if (!result.value) {
        return
      }

      await this.$firestoreRefs.item.delete()

      if (this.after_write) {
        await this.after_write()
      }

      this.$router.push({name: `${this.collection}s`})
    },
    async create_item() {
      this.$v.item.$touch()
      if (this.$v.item.$anyError) {
        return
      }

      this.item.created = new Date()
      this.item.updated = new Date()

      this.is_saving = true
      let item_doc = this.$firestoreRefs._item
      await item_doc.set(this.item)

      if (this.after_write) {
        await this.after_write()
      }

      this.is_saving = false

      if (this.after) {
        this.after()
      } else {
        this.$router.push({name: this.collection, params: {id: item_doc.id}})
      }
    }
  }
}
